import { IError, RootGizmo } from "flowy-3-core";
import { FC, useEffect, useState } from "react";
import WarningModal from "./WarningsModal";
import ErrorModal from "./ErrorModal";

type FormErrorsProps = {
  errors: IError[];
  rootGizmo: RootGizmo;
};

const FormErrors: FC<FormErrorsProps> = ({ errors, rootGizmo }) => {
  const [, setVisible] = useState(true);
  const [modalType, setModalType] = useState<"error" | "warning" | undefined>();

  useEffect(() => {
    if (errors.length > 0) {
      if (errors[0].data) {
        // This means it's a warning
        setModalType("warning");
      } else {
        setModalType("error");
      }
      setVisible(true);
    }
  }, [errors]);

  return (
    <div>
      {modalType === "error" && <ErrorModal errors={errors} />}
      {modalType === "warning" && (
        <WarningModal errors={errors} rootGizmo={rootGizmo} />
      )}
      {/* {errors.length > 0 && (
        <Modal
          open={visible}
          title={
            <div>
              <CloseCircleFilled style={{ color: "red" }} /> Error
            </div>
          }
          footer={[
            <Button
              style={{ backgroundColor: "#AB0A3D", color: "white" }}
              onClick={() => setVisible(false)}
            >
              Aceptar
            </Button>,
          ]}
          style={{ top: 20 }}
        >
          {errors.length > 0 &&
            errors.map((error: IError) => (
              <span key={error.fid}>
                <Text>{error.message}</Text>
                <br />
              </span>
            ))}
        </Modal>
      )} */}
    </div>
  );
};

export default FormErrors;
